export default "__VITE_ASSET__SVcn7_52__"